import { render, staticRenderFns } from "./asidenav.vue?vue&type=template&id=87c45e42&scoped=true&"
import script from "./asidenav.vue?vue&type=script&lang=js&"
export * from "./asidenav.vue?vue&type=script&lang=js&"
import style0 from "./asidenav.vue?vue&type=style&index=0&id=87c45e42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c45e42",
  null
  
)

export default component.exports